import { render, staticRenderFns } from "./InvalidWallboardNumber.vue?vue&type=template&id=9de10d34&scoped=true&"
import script from "./InvalidWallboardNumber.vue?vue&type=script&lang=js&"
export * from "./InvalidWallboardNumber.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9de10d34",
  null
  
)

export default component.exports